import { Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Logo & Description */}
          <div>
            {/* Text-Logo für dunklen Hintergrund */}
            <div className="flex items-center gap-2 mb-4">
              {/* Fotobox Icon */}
              <svg width="32" height="32" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="10" width="32" height="26" rx="3" stroke="#3ECDC3" strokeWidth="3" fill="none"/>
                <circle cx="20" cy="23" r="7" stroke="#3ECDC3" strokeWidth="3" fill="none"/>
                <rect x="14" y="4" width="4" height="8" rx="1" fill="#3ECDC3"/>
                <rect x="22" y="4" width="4" height="8" rx="1" fill="#3ECDC3"/>
              </svg>
              {/* Text */}
              <span className="text-2xl font-bold" >
                <span className="text-white">geile</span>
                <span className="text-[#3ECDC3] ml-1">Kiste</span>
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Fotobox-Verleih für unvergessliche Momente am Bodensee, Singen, Radolfzell, Konstanz und Umgebung.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold mb-4 text-sm tracking-wider">Navigation</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => document.getElementById('events')?.scrollIntoView({ behavior: 'smooth' })} className="text-gray-400 hover:text-[#3ECDC3] transition-colors text-sm cursor-pointer">
                  Events
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })} className="text-gray-400 hover:text-[#3ECDC3] transition-colors text-sm cursor-pointer">
                  Preise
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth' })} className="text-gray-400 hover:text-[#3ECDC3] transition-colors text-sm cursor-pointer">
                  FAQ
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })} className="text-gray-400 hover:text-[#3ECDC3] transition-colors text-sm cursor-pointer">
                  Kontakt
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold mb-4 text-sm tracking-wider">Kontakt</h4>
            <ul className="space-y-4">
              <li>
                <a 
                  href="tel:+4915223958867" 
                  className="flex items-center gap-3 text-gray-400 hover:text-[#3ECDC3] transition-colors text-sm"
                >
                  <Phone className="w-4 h-4 text-[#3ECDC3]" />
                  +49 (0) 152 239 588 67
                </a>
              </li>
              <li className="flex items-start gap-3 text-gray-400 text-sm">
                <MapPin className="w-4 h-4 text-[#3ECDC3] flex-shrink-0 mt-0.5" />
                <span>Region Bodensee<br />Singen, Radolfzell, Konstanz, Stockach</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {currentYear} geile Kiste. Alle Rechte vorbehalten.
          </p>
          <p className="text-gray-500 text-sm">
            Gemacht mit <span className="text-red-500">❤️</span> by{' '}
            <a 
              href="https://www.apppilot.de" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#3ECDC3] hover:underline"
            >
              AppPilot.de
            </a>
          </p>
          <div className="flex gap-6">
            <Link 
              to="/impressum" 
              className="text-gray-500 hover:text-[#3ECDC3] transition-colors text-sm"
              data-testid="footer-impressum-link"
            >
              Impressum
            </Link>
            <Link 
              to="/datenschutz" 
              className="text-gray-500 hover:text-[#3ECDC3] transition-colors text-sm"
              data-testid="footer-datenschutz-link"
            >
              Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
